import React from 'react'
import { useTranslation } from 'react-i18next'

import { FieldProps } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'
import { TextInput } from '../../../../../../common/inputs/textInput/TextInput'
import { getDefaultClasses } from '../../../../../../../utils/style-utils'

const ServiceCharge: React.FC<FieldProps<OtherFacilitiesScreenValidationResult>> = ({
  screenName,
  insertionData,
  validationMessages,
  onChange,
  wrapperClassName = getDefaultClasses('full'),
}) => {
  const { t } = useTranslation()
  return (
    <div className={wrapperClassName}>
      <TextInput
        id='service-charge'
        propertyName='serviceCharge'
        placeholder=''
        label={<span>{t('wizard.screen.otherFacilities.serviceCharge', 'Service Charge')}</span>}
        value={insertionData.serviceCharge}
        maxLength={14}
        type='text'
        affixRight='unit'
        unitRight='eur'
        errors={validationMessages!.serviceCharge ?? []}
        doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
      />
    </div>
  )
}
export default ServiceCharge
